module.exports = __webpack_public_path__ + "img/medicamentos.200a50cb.svg";